<template>
  <card>
    <h3 slot="header" class="mb-0">Task Template for ({{ model.task_template_name }}) </h3>
    <div class="text-right">
      <router-link :to="'/templates/projectTaskTemplateEdit/' + model.project_task_template_id">
        <base-button size="sm" type="primary"
        v-if="button_access.edit_template_button == 'YES' && myUserID.role_id == 3">Edit</base-button>
      </router-link>
    </div>
    <form class="needs-validation"
          @submit.prevent="submit">

      <div class="form-row">
        <b-col md="12">
          <base-input label="Template Name"
                      name="Template Name"
                      placeholder="Template Name"
                      v-model="model.task_template_name" disabled>
          </base-input>
        </b-col>
      </div>
    </form>
  </card>
</template>
<script>
  import BaseSlider from '@/components/BaseSlider'
  import {LoginURL, clientId, clientSecret, apiDomain, getHeader} from '@/assets/js/config.js'
  import axios from 'axios'
  import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'

  export default {
    mixins: [ErrorFunctionMixin],
    components: {
      BaseSlider
    },
    created()
    {
      var project_task_template_access = JSON.parse(window.localStorage.getItem('project_task_template_access'))
      this.button_access.edit_template_button = project_task_template_access.access_edit

      const LoginUser = JSON.parse(window.localStorage.getItem('loginUser'))
      this.myUserID = LoginUser

      this.model.project_task_template_id = this.$route.params.id

      axios.get(apiDomain + 'template/project_task_template/'+this.model.project_task_template_id, { headers: getHeader() })
      .then ( response => {
        if (response.status === 200)
        {
          this.model.project_task_template_id = response.data.data[0].project_task_template_id
          this.model.task_template_name = response.data.data[0].task_template_name
        }
      })
      .catch ( error => {
          console.log(error.response.status)
          this.errorFunction(error, "Project Task Template Information")
      } );
    },
    data() {
      return {
        model: {
          task_template_name: null,
          project_task_template_id: null,
        },
         button_access:{
          edit_template_button: null,
        },
        myUserID: null,
      }
    },
    methods: {


    }
  }
</script>
<style>
</style>
